module.exports = __webpack_public_path__ + "static/media/default_qr_code.497aa6e7.png";